import axios from '../axios';
import { buildGetTeamsByBranchUrl } from '../ApiUrl';

/**
 * GET /GetTeamsByBranch?branchName=...
 * @param {string} branchName — sent trimmed + lowercased (matches TeamSignupBranch / backend).
 */
export const getTeamsByBranchAPI = async (branchName) => {
  const bn = String(branchName ?? '').trim().toLowerCase();
  if (!bn) {
    return { hasError: true, message: 'branchName is required' };
  }
  try {
    const response = await axios.get(buildGetTeamsByBranchUrl(bn));
    return response;
  } catch (error) {
    console.log('getTeamsByBranchAPI catch', error);
    return { hasError: true, error };
  }
};
